import React from 'react'

import Chart from '@icons/Chart.inline.svg'
import Safe from '@icons/Safe.inline.svg'
import Money from '@icons/Money.inline.svg'
import Time from '@icons/Time.inline.svg'
import Pin from '@icons/Pin.inline.svg'
import Crown from '@icons/Crown.inline.svg'
import { ICard } from './Card'

export type TCardData = Omit<ICard, 'number'>

export const sarovCards: TCardData[] = [
  {
    heading: 'Удвоенный личный взнос',
    text: (
      <>
        Минимальный размер пенсионного взноса работника 500 ₽/мес.
        <br />
        <br />
        Максимальный размер пенсионного взноса вкладчика 5000 ₽/мес.
      </>
    ),
    icon: <Safe />,
  },
  {
    heading: 'Инвестиционный доход',
    text: (
      <>
        На ваши накопления ежегодно начисляется инвестиционный доход НПФ Сбербанка.
        <br />
        <br />
        Среднегодовой инвестиционный доход за последние 3 года составляет более 7%.
      </>
    ),
    icon: <Chart />,
    button: {
      link: true,
      href: 'https://npfsberbanka.ru/about/information-to-be-disclosed/results/#profitability',
    },
  },
  {
    heading: 'Повышенный размер первой выплаты',
    text: (
      <>
        Срочная пенсия не менее 5 лет.
        <br />
        <br />
        Первая выплата до 25% от накопленного пенсионного капитала.
      </>
    ),
    icon: <Money />,
  },
  {
    heading: 'Пенсионные каникулы',
    text: (
      <>
        Работник имеет право брать «пенсионные каникулы» — приостанавливать уплату пенсионных взносов на срок до 2-х лет
        без исключения работника из КПП.
      </>
    ),
    icon: <Pin />,
  },
  {
    heading: 'Правопреемство',
    text: (
      <>
        Пенсионные средства, сформированные работником выплачиваются в любой период (до полного исполнения
        обязательств).
        <br />
        <br />
        Пенсионные средства, перечисленные работодателем, выплачиваются при наличии средств на пенсионном счете. По
        взносам софинансирования выплата производится, если счет находится на этапе накопления или назначена срочная
        выплата. По единовременным взносам – в любой момент.
      </>
    ),
    icon: <Time />,
  },
  {
    heading: 'Социальный налоговый вычет',
    icon: <Crown />,
    text: (
      <>
        С личных взносов сотрудника в корпоративную программу можно получить налоговый вычет.
        <br />
        <br />
        Максимальная сумма взносов с которой можно вернуть НДФЛ составляет 120 000 рублей в год, при этом размер
        возврата составляет – 15 600 рублей в год.
      </>
    ),
  },
]

export const aeroCards: TCardData[] = [
  {
    heading: 'Гарантированный ежемесячный 20% доход от Аэрофлота',
    text: <>На каждые 1000 рублей сотрудника Аэрофлот добавляет 200 рублей.</>,
    icon: <Safe />,
  },
  {
    heading: 'Чем больше взнос, тем больше доход',
    text: (
      <>
        20% начисляется на каждый взнос сотрудника, для этого важно подать Заявление на удержание из заработной платы в
        бухгалтерию Аэрофлота.
      </>
    ),
    icon: <Chart />,
  },
  {
    heading: 'Ежегодно начисляется инвестиционный доход',
    text: (
      <>
        Инвестиционный доход от СберНПФ ежегодно начисляется на личный и корпоративный счета сотрудника, и исторически
        превышает инфляцию.
      </>
    ),
    icon: <Money />,
  },
  {
    heading: 'Налоговый вычет до 15 600 ₽ в год',
    text: (
      <>
        При подаче Заявления на получение налогового вычета в бухгалтерию Аэрофлота, налоговый вычет возвращается
        автоматически, без посещения ФНС. Максимальная сумма взносов, с которой возможно вернуть НДФЛ, составляет 120
        000 рублей в год.
      </>
    ),
    icon: <Pin />,
  },
  {
    heading: 'Копить с Аэрофлот и СберНПФ безопасно',
    text: (
      <>
        Аэрофлот ежемесячно софинансирует вложения сотрудников, СберНПФ вкладывает деньги в надежные инструменты, все
        счета защищены от претензий 3-х лиц. Не могут быть разделены при разводе, наследуются.
      </>
    ),
    icon: <Time />,
  },
]
